import http from './api'

const route = 'app/usuario/'

export default {
  saveUser: (usuario, tokenContrato, url) => {
    return http.post(route + 'saveUser', {
      usuario: usuario,
      tokenContrato: tokenContrato,
      url: url,
    })
  },

  showUser: (username, tokenContrato) => {
    return http.post(route + 'showUser', {
      username: username,
      tokenContrato: tokenContrato,
    })
  },

  atualizarUsuario: (usuario, tokenContrato, url) => {
    return http.post(route + 'atualizarUsuario', {
      usuario: usuario,
      tokenContrato: tokenContrato,
      url: url,
    })
  },

  altualizarStatus: (usuario, tokenContrato) => {
    return http.post(route + 'altualizarStatus', {
      usuario: usuario,
      tokenContrato: tokenContrato,
    })
  },
}
